import "../css/newsletter.css";

const parseConfig = () => {
  const node = document.querySelector("#nanzora-storefront-config");
  if (!node) return {};
  try {
    return JSON.parse(node.textContent);
  } catch {
    return {};
  }
};

const config = parseConfig();

const postJson = async (path, body) => {
  const response = await fetch(`${config.restUrl}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-WP-Nonce": config.restNonce ?? "",
    },
    body: JSON.stringify(body),
  });
  return response.json();
};

document.querySelectorAll("[data-nanzora-newsletter]").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const status = form.querySelector(".nanzora-form-status");
    const data = new FormData(form);
    if (data.get("email_marketing") !== "yes") {
      if (status) {
        status.textContent = "Please confirm you want email updates.";
      }
      return;
    }
    const result = await postJson("newsletter", {
      email: data.get("email"),
      email_marketing: "yes",
    });
    if (status) {
      status.textContent = result.ok
        ? "Check your inbox to confirm, or you’re on the list."
        : "We could not subscribe that address.";
    }
    if (result.ok) {
      form.reset();
    }
  });
});

document.querySelectorAll("[data-nanzora-stock-alert]").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const status = form.querySelector(".nanzora-form-status");
    const data = new FormData(form);
    const result = await postJson("stock-alert", {
      email: data.get("email"),
      product_id: Number(data.get("product_id")),
      variation_id: Number(data.get("variation_id") || 0),
    });
    if (status) {
      status.textContent = result.ok
        ? "We will email you if this returns. Availability can change."
        : "We could not save that alert.";
    }
  });
});

document.querySelectorAll("[data-nanzora-price-alert]").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const status = form.querySelector(".nanzora-form-status");
    const data = new FormData(form);
    if (data.get("price_drop") !== "yes") {
      if (status) {
        status.textContent = "Tick the box to opt in to a price alert.";
      }
      return;
    }
    const result = await postJson("price-alert", {
      email: data.get("email"),
      product_id: Number(data.get("product_id")),
    });
    if (status) {
      status.textContent = result.ok
        ? "We will email you if this price drops."
        : "We could not save that alert.";
    }
  });
});
